<div class="main-container"style="background-color: #ffffff;">
  <div class="container" style="min-height: 600px; background-color: #ffffff; margin-top: 10px;">
    <form [formGroup]="reportForm" (ngSubmit)="fetchReport()" class="form-grid">
      <!-- Row 1: Products & Venues -->
      <div class="row">
        <div class="form-group col-md-6 col-12">
          <label class="fieldName" style="font-size:12px; display: block;">SERVICES</label>
          <ng-multiselect-dropdown
            [placeholder]="'Select Products'"
            [data]="products"
            formControlName="productIds"
            [settings]="dropdownProductSettings">
          </ng-multiselect-dropdown>
        </div>

        <div class="form-group col-md-6 col-12">
          <label class="fieldName" style="font-size: 12px;">VENUES</label>
          <ng-multiselect-dropdown
            [placeholder]="'Select Venues'"
            [data]="venues"
            formControlName="venueIds"
            [settings]="dropdownVenueSettings">
          </ng-multiselect-dropdown>
        </div>
      </div>

      <!-- Row 2: Period & Date Range -->
      <div class="row">
        <div class="form-group col-md-2 col-12">
          <label class="fieldName" style="font-size: 12px;">PERIOD</label>
          <select formControlName="period" (change)="setPeriod($event.target.value)">
            <option *ngFor="let p of periods" [value]="p" style="font-size: 12px;font-weight: bold; font-family: 'Nunito-B'">{{ p }}</option>
          </select>
        </div>

        <div class="form-group col-md-2 col-12" *ngIf="reportForm.value.period === 'Custom'">
          <label class="fieldName" style="font-size: 12px;" >FROM</label>
          <input type="date" formControlName="startDate" />
        </div>

        <div class="form-group col-md-2 col-12" *ngIf="reportForm.value.period === 'Custom'">
          <label class="fieldName" style="font-size: 12px;">TO</label>
          <input type="date" formControlName="endDate" />
        </div>
        <div class="form-group col-md-6 col-12 d-flex justify-content-end align-items-end" style="margin-top: 25px;">
          <div class="form-actions">
            <button type="submit" class="btn btn-primary me-2 book-now-btn">Fetch Report</button>
            <button type="button" class="btn btn-secondary pop-up-btn-white" (click)="downloadCSV()" [disabled]="downloading">Download</button>
          </div>
        </div>
      </div>



      <!-- Row 3: Buttons & Metrics -->
      <div class="row justify-content-between align-items-center mt-2 form-actions-row">
        <div class="report-summary">
          <div class="summary-item summary-total">
            <span class="status">Total</span>
            <div class="value-row">
              <span class="count">{{ summary.total }}</span>
              <span class="amount">₹{{ summary.totalAmount }}</span>
            </div>
          </div>
          <div class="summary-item summary-booked">
            <span class="status">Booked</span>
            <div class="value-row">
              <span class="count">{{ summary.booked }}</span>
              <span class="amount">₹{{ summary.bookedAmount }}</span>
            </div>
          </div>
          <div class="summary-item summary-cancelled">
            <span class="status">Cancelled</span>
            <div class="value-row">
              <span class="count">{{ summary.cancelled }}</span>
              <span class="amount">₹{{ summary.cancelledAmount }}</span>
            </div>
          </div>
          <div class="summary-item summary-failed">
            <span class="status">Failed</span>
            <div class="value-row">
              <span class="count">{{ summary.failed }}</span>
              <span class="amount">₹{{ summary.failedAmount }}</span>
            </div>
          </div>
        </div>

      </div>

    </form>

    <!-- AG Grid -->
    <div *ngIf="reportData?.length > 0" class="ag-wrapper mt-4">
      <ag-grid-angular
        class="ag-theme-alpine"
        style="width: 100%; height: 600px;"
        [rowData]="reportData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [animateRows]="true"
        [suppressRowClickSelection]="true"
        rowSelection="multiple">
      </ag-grid-angular>
    </div>
  </div>
</div>
